import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import {
  CLOSE_BUTTON,
  ERROR_MESSAGE,
  WAITLIST_TITLE
} from 'constants/waitlistStrings';

/**
 * Unity parity: TablesView.cs:1763 OnFailedJoinWaitlist.
 * Shown when the join-waitlist REST call fails — title/body/button
 * exactly match Unity's ModalView.ShowAlert.
 */
type JoinWaitlistFailedAlertProps = {
  open: boolean;
  onClose: () => void;
};

const JoinWaitlistFailedAlert: React.FC<JoinWaitlistFailedAlertProps> = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} aria-labelledby='join-waitlist-failed-title'>
    <DialogTitle id='join-waitlist-failed-title'>{WAITLIST_TITLE}</DialogTitle>
    <DialogContent style={{ whiteSpace: 'pre-line' }}>{ERROR_MESSAGE}</DialogContent>
    <DialogActions>
      <Button onClick={onClose} aria-label='close-join-waitlist-failed'>
        {CLOSE_BUTTON}
      </Button>
    </DialogActions>
  </Dialog>
);

export default JoinWaitlistFailedAlert;
